import DataApi from './DataApi';

/** Apply sharing rules to record_access (evaluate criteria, upsert grants). */
class SharingApi extends DataApi {
  constructor() {
    super('sharing');
  }

  applyRule(ruleId) {
    return this.post(`/rules/${encodeURIComponent(ruleId)}/apply`, {});
  }
}

export default SharingApi;
